import type { DashboardLayoutResponse } from "@/features/dashboard/types/dashboardLayout";
import { fetcher } from "@/shared/lib/fetcher.client";

const DASHBOARD_LAYOUT_ENDPOINT = "/dashboard_layout";

export const getDashboardLayout =
  async (): Promise<DashboardLayoutResponse> => {
    const response = await fetcher.get<DashboardLayoutResponse>(
      DASHBOARD_LAYOUT_ENDPOINT,
    );
    return response.data;
  };
